module.exports = __webpack_public_path__ + "static/img/10-1.ba365196.jpg";